export type PaperSize = 'A4' | 'A3'
export type Orientation = 'portrait' | 'landscape'
export type PrintScale = 100 | 90 | 80 | 70 | 60 | 50

export const SCALE_OPTIONS: { value: PrintScale; label: string }[] = [
  { value: 100, label: '100%' },
  { value: 90, label: '90%' },
  { value: 80, label: '80%' },
  { value: 70, label: '70%' },
  { value: 60, label: '60%' },
  { value: 50, label: '50%' }
]

export const PAPER_DIMENSIONS: Record<PaperSize, { width: number; height: number }> = {
  A4: { width: 210, height: 297 },
  A3: { width: 297, height: 420 }
}

export type MarginSize = 'small' | 'medium' | 'large'

export const MARGIN_VALUES: Record<MarginSize, number> = {
  small: 5,
  medium: 10,
  large: 20
}

export const MARGIN_OPTIONS: { value: MarginSize; label: string }[] = [
  { value: 'small', label: 'Pieni' },
  { value: 'medium', label: 'Keski' },
  { value: 'large', label: 'Suuri' }
]

export const WATERMARK = {
  text: 'Powered by Finadeck | finadeck.com',
  color: '#d5d5d5',
  fontSize: '7pt',
  fontFamily: 'Manrope, sans-serif'
}

export type OutputFormat = 'pdf' | 'png' | 'jpg'

export const FORMAT_OPTIONS: { value: OutputFormat; label: string; description: string }[] = [
  { value: 'pdf', label: 'PDF-dokumentti', description: 'Säilyttää muotoilun parhaiten' },
  { value: 'png', label: 'PNG-kuva', description: 'Korkealaatuinen häviötön kuva' },
  { value: 'jpg', label: 'JPG-kuva', description: 'Optimoitu tiedostokoko' }
]

export const isImageFormat = (format: OutputFormat): boolean => format === 'png' || format === 'jpg'

export const MM_TO_PX = 96 / 25.4
export const GAP_PX = 4 * MM_TO_PX

export function computePrintableWidthPx(settings: {
  paperSize: PaperSize
  orientation: Orientation
  scale: PrintScale
  margin: MarginSize
}): number {
  const dim = PAPER_DIMENSIONS[settings.paperSize]
  const paperWidthMm = settings.orientation === 'portrait' ? dim.width : dim.height
  const marginMm = MARGIN_VALUES[settings.margin]
  return (paperWidthMm - 2 * marginMm) * (100 / settings.scale) * MM_TO_PX
}

export function buildSectionWidthMap(printableWidthPx: number, colSpanMap: Map<string, number>): Map<string, number> {
  const frSize = (printableWidthPx - 11 * GAP_PX) / 12
  const map = new Map<string, number>()
  for (const [name, colSpan] of colSpanMap) {
    map.set(name, colSpan * frSize + (colSpan - 1) * GAP_PX)
  }
  return map
}
